import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiResponseModel, ApiVisa, BaseApiTemplateService} from '../../shared';
import {Core2Config} from '../../shared';
import {
  ClaimEntitlementAutoTopUpRunJobRoleFilterContainerModel
} from '../../../../../../models';
import {Observable} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ClaimEntitlementAutoTopUpRunJobRoleFilterService extends BaseApiTemplateService<ClaimEntitlementAutoTopUpRunJobRoleFilterContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +
    Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-runs/filter-job-roles/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +
      Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-runs/filter-job-roles/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-runs/filter-job-roles/backoffice-ep';
    this.httpClient = http;
  }

  postMultipleFilter(body: ClaimEntitlementAutoTopUpRunJobRoleFilterContainerModel[], visa: ApiVisa):
    Observable<ApiResponseModel<ClaimEntitlementAutoTopUpRunJobRoleFilterContainerModel>>  {
    let url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-runs/filter-job-roles/multiple/backoffice-ep';
    if (visa.api_domain_url) {
      url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
        Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-runs/filter-job-roles/multiple/backoffice-ep';
    }

    return this.httpClient.post<ApiResponseModel<ClaimEntitlementAutoTopUpRunJobRoleFilterContainerModel>>(
      url,
      body,
      this.getHttpHeader(visa)
    );
  }

}


